"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInput = void 0;
const formik_1 = require("formik");
const get_value_1 = __importDefault(require("get-value"));
const react_1 = __importDefault(require("react"));
exports.BaseInput = (props) => {
    const { id, label, name, inline, inlineLabelWidth, labelClass, className, children, placeholder, hideLabel, wrapperClassName, } = props;
    const getErrorMessageField = () => (react_1.default.createElement("div", { className: "invalid-feedback" },
        react_1.default.createElement(formik_1.ErrorMessage, { name: name })));
    const getInvalidClass = ({ field, form: { touched, errors } }) => get_value_1.default(errors, field.name) && get_value_1.default(touched, field.name) ? 'is-invalid' : '';
    const getInputClass = (fieldProps, baseClassName = 'form-control') => `${baseClassName} ${className || ''} ${getInvalidClass(fieldProps)}`;
    const getId = () => id || `${name}-input`;
    const getPlaceholder = () => placeholder || label;
    let inlineWidth = 4;
    if (typeof inlineLabelWidth === 'number')
        inlineWidth = inlineLabelWidth;
    const inputWidth = 12 - inlineWidth;
    return (react_1.default.createElement("div", { className: `${wrapperClassName || 'form-group'} ${inline ? 'row' : ''}` },
        !hideLabel ? (react_1.default.createElement("label", { htmlFor: id || `${name}-input`, className: `${labelClass || ''} ${inline ? `col-md-${inlineWidth} col-form-label` : ''}` }, label)) : (''),
        react_1.default.createElement("div", { className: inline ? `col-md-${inputWidth}` : '' }, children({ getErrorMessageField, getInputClass, getPlaceholder, getId, getInvalidClass }))));
};
//# sourceMappingURL=BaseInput.js.map